import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Body = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
}));

export const SenderBox = styled(Box, {
  shouldForwardProp: props => props !== 'hidden',
})(({ theme, hidden }) => ({
  backgroundColor: 'rgba(255,255,255,0.16862745098039217 )',
  paddingTop: '19px',
  paddingBottom: '14px',
  paddingLeft: '27px',
  paddingRight: hidden ? '0px' : '27px',
  marginTop: '10px',
  marginRight: hidden ? '0px' : '15px',
  marginBottom: '10px',
  borderRadius: '30px 30px 30px 0%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  color: 'white',
}));

export const TipBox = styled(SenderBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
}));

export const TipPriceBox = styled(Box)(({ theme }) => ({
  borderRadius: '7px',
  borderColor: '#ffffff',
  borderWidth: '2px',
  borderStyle: 'solid',
  paddingRight: '5px',
  paddingLeft: '5px',
  paddingTop: '2px',
  paddingBottom: '2px',
  display: 'flex',
  width: 'fit-content',
  height: 'fit-content',
  alignItems: 'center',
}));

export const PostBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#494855',
  margin: '10px 0px',
  padding: '20px 25px',
  borderRadius: '10px',
}));

export const RecieverBox = styled(SenderBox)(({ theme }) => ({
  backgroundColor: '#36899f',
  marginLeft: '15px',
  marginRight: '0px',
  borderRadius: '30px 30px 0px 30px',
  position: 'relative',
  color: 'white',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
}));

export const MessageText = styled(Typography, {
  shouldForwardProp: props => props !== 'hidden',
})(({ theme, hidden, borderRadius }) => ({
  fontSize: '16px',
  color: '#ffffff',
  backgroundColor: hidden
    ? 'rgba(0,0,0,0.3)'
    : borderRadius
    ? 'rgba(255,255,255,0.16862745098039217 )'
    : '#36899f',
  borderRadius: hidden
    ? '30px'
    : borderRadius
    ? '30px 30px 30px 0%'
    : '30px 30px 0px 30px',
  position: 'relative',
  width: 'fit-content',
  padding: '10px 20px',
  marginTop: '10px',
}));

export const TipText = styled(MessageText)(({ theme }) => ({
  fontStyle: 'italic',
}));

// export const TimeText = styled(MessageText)(({ theme }) => ({
//   color: '#848484',
// }));

export const imgStyles = {
  width: '100%',
  height: '50%',
  maxHeight: '400px',
  maxWidth: '300px',
  objectFit: 'cover',
  borderRadius: '10px',
  cursor: 'pointer',
  background: '#313646',
  position: 'relative',
  overflowX: 'hidden',
} as React.CSSProperties;

export const ReplyImgStyles = {
  height: '120px',
  objectFit: 'contain',
  borderRadius: '20px',
  opacity: 0.6,
} as React.CSSProperties;
